import { Box, Typography } from "@mui/material";
import { isEmpty } from "lodash";

export const PricelistItems = ({ items, disabled, editable, inline, loading }) => {
    if (isEmpty(items)) {
        return null;
    }
    return (
        <Box>
            {items.map((item, key) => (
                <Box key={key} sx={{ borderBottom: "1px solid red", py: 1 }}>
                    <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                        <Typography>{item.type}</Typography>
                    </Box>
                    <pre>{JSON.stringify(item, null, 4)}</pre>
                </Box>
            ))}
        </Box>
    );
};
